import script from "./MailBox.vue?vue&type=script&setup=true&lang=js"
export * from "./MailBox.vue?vue&type=script&setup=true&lang=js"

import "./MailBox.vue?vue&type=style&index=0&id=d33d4ae6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d33d4ae6"]])

export default __exports__